import type { JSONContent } from '@tiptap/core';

import type { CodeBlockExtensionOptions } from '@spotify/confidence-core-react';

const getInlineCodeContent = (node: JSONContent): string | null => {
  if (node.type !== 'paragraph' || !node.content?.length) {
    return null;
  }

  let content = '';
  for (const child of node.content) {
    if (child.type === 'hardBreak') {
      content += '\n';
      continue;
    }

    const isInlineCode = child.marks?.some(mark => mark.type === 'code');
    if (child.type !== 'text' || !isInlineCode || !child.text) {
      return null;
    }
    content += child.text;
  }

  return content;
};

export const normalizeLegacyCodeBlocks = (
  content: JSONContent,
  extensions: readonly CodeBlockExtensionOptions[],
): JSONContent => {
  const inlineCodeContent = getInlineCodeContent(content);
  if (inlineCodeContent !== null) {
    const codeBlockItem = extensions
      .map(extension => extension.parseLegacyContent?.(inlineCodeContent))
      .find(item => item !== null && item !== undefined);

    if (codeBlockItem) {
      return {
        type: 'codeBlock',
        attrs: { language: codeBlockItem.language },
        content: [{ type: 'text', text: codeBlockItem.content }],
      };
    }
  }

  if (!content.content) {
    return content;
  }

  return {
    ...content,
    content: content.content.map(child =>
      normalizeLegacyCodeBlocks(child, extensions),
    ),
  };
};
